<template>
  <div>
    <p class="font-semibold leading-normal">
      {{ customerFullName }}
    </p>

    <div>
      <span
        :class="[
          'bg-background-fg/8 mx-auto inline-flex items-center rounded-full py-0.5 pl-2 text-xs',
          customer.phone ? 'pr-0.5' : 'pr-2',
        ]"
      >
        {{ customer.membershipNumber || "Not Member" }}
        <div
          v-if="customer.phone"
          class="ml-2 flex h-full items-center justify-center rounded-full bg-white p-0.5"
        >
          <component :is="iconComponent" class="h-4/5 w-4/5" />
        </div>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  customerDisplayName,
  type Customer,
} from "@/services/bookings/customers";
import PhoneIcon from "~icons/fa6-solid/phone-flip";
import MobileIcon from "~icons/fa6-solid/mobile";

const props = defineProps<{ customer: Customer; isCompanion?: boolean }>();

const iconComponent = computed(() =>
  props.isCompanion ? MobileIcon : PhoneIcon,
);

const customerFullName = computed<string>(() =>
  customerDisplayName(props.customer),
);
</script>
